
(function() {
    'use strict';

    var formData;
    var category;


    category = 'newsletter';
    var onfocus = false,
        maxEmail,
        maxForms;


    window.addEventListener('message', function() {

        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {

            var formEmail = document.querySelectorAll('.newsletter__form form input[type=email]');

            for (var i = 0, maxEmail = formEmail.length; i < maxEmail; i++) {
                formEmail[i].addEventListener('click', formStart);
            }
        }

        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
            formData = event.data.data;
        }

        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
            formSubmitted();

            var form = document.querySelectorAll('.newsletter__form'),
                successMessage = document.querySelectorAll('.newsletter__success'),
                successTxt = document.querySelectorAll('[gr-newsletter-confirm-msg]'),
                lang = document.documentElement.lang;

            if (form) {
                for (var x = 0, maxForms = form.length; x < maxForms; x++) {
                    form[x].style.display = 'none';
                    successMessage[x].style.display = 'block';

                    if (lang == 'en') {
                        successTxt[x].innerHTML = 'Thank you for your registration!';
                    } else {
                        successTxt[x].innerHTML = 'Merci de votre inscription!';
                    }
                }
            }
        }
    });


    function formStart() {

        if (!onfocus) {
            dataLayer.push({
                "object": {
                    "Id": "OBJ006",
                    "name": "Newsletter - Start"
                },
                "event": "VPV",
                "gaStep": {
                    "value": "1-newsletter-start"
                },
                "form": {
                    "category": category
                }
            });

            onfocus = true;
        }
    }

    function formSubmitted() {

        dataLayer.push({
            "object": {
                "Id": "OBJ007",
                "name": "Newsletter - Sent"
            },
            "event": "VPV",
            "gaStep": {
                "value": "2-newsletter-sent"
            },
            "form": {
                "category": category,
                "fields": formData
            }
        });
    }

})();
